"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8622],{

/***/ 8622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ArticleImageGallery; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ArticleImageGallery.js






const y = "article-image-gallery", d = "article-image-gallery__one_image-container", p = "desktop", G = "article-gallery-image", I = "article-image-gallery__one_text-container", C = "article-image-gallery__two", E = "article-image-gallery__two--first", T = "article-image-gallery__two--second", w = "article-gallery-credits", N = "article-gallery-caption", a = {
  articleImageGallery: y,
  articleImageGalleryOneImageContainer: d,
  desktop: p,
  articleGalleryImage: G,
  articleImageGalleryOneTextContainer: I,
  articleImageGalleryTwo: C,
  articleImageGalleryTwoFirst: E,
  articleImageGalleryTwoSecond: T,
  articleGalleryCredits: w,
  articleGalleryCaption: N
};
function b({
  creditsLabel: i = "Credits",
  images: r = []
}) {
  if (r.length < 1)
    return null;
  const [l, t] = r;
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      className: a.articleImageGallery,
      "data-testid": "article-image-gallery-block"
    },
    /* @__PURE__ */ react.createElement(
      Block_9b78bd10.B.Content,
      {
        "data-testid": "article-image-gallery-block-content",
        itemScope: !0,
        itemType: "https://schema.org/ImageObject"
      },
      t ? /* @__PURE__ */ react.createElement(
        u,
        {
          creditsLabel: i,
          image: l,
          image2: t,
          "data-testid": "gallery-two-images"
        }
      ) : /* @__PURE__ */ react.createElement(
        _,
        {
          creditsLabel: i,
          image: l,
          "data-testid": "gallery-one-image"
        }
      )
    )
  );
}
function _(i) {
  const { image: r, creditsLabel: l } = i, { caption: t, credits: m, ...g } = r;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: a.articleImageGalleryOneImageContainer }, /* @__PURE__ */ react.createElement(
    Image_d6406817.I,
    {
      ...g,
      credits: m,
      className: a.articleGalleryImage
    }
  )), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(
        app_a75c1d35.t.textsCaption,
        a.articleImageGalleryOneTextContainer
      )
    },
    m && /* @__PURE__ */ react.createElement("p", { className: a.articleGalleryCredits, itemProp: "creditText" }, l, ": ", m),
    t && /* @__PURE__ */ react.createElement("p", { className: a.articleGalleryCaption, itemProp: "caption" }, t)
  ));
}
function u(i) {
  const { creditsLabel: r, image: l, image2: t } = i;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
    "div",
    {
      "data-testid": "article-image-gallery-first",
      className: (0,app_a75c1d35.c)(
        a.articleImageGalleryTwo,
        a.articleImageGalleryTwoFirst,
        app_a75c1d35.t.textsCaption
      )
    },
    /* @__PURE__ */ react.createElement(
      Image_d6406817.I,
      {
        ...l,
        className: a.articleGalleryImage,
        "data-testid": "article-image-gallery-image"
      }
    ),
    l.credits && /* @__PURE__ */ react.createElement("p", { className: a.articleGalleryCredits, itemProp: "creditText" }, r, ": ", l.credits),
    l.caption && /* @__PURE__ */ react.createElement("p", { className: a.articleGalleryCaption, itemProp: "caption" }, l.caption)
  ), /* @__PURE__ */ react.createElement(
    "div",
    {
      "data-testid": "article-image-gallery-second",
      className: (0,app_a75c1d35.c)(
        a.articleImageGalleryTwo,
        a.articleImageGalleryTwoSecond,
        app_a75c1d35.t.textsCaption
      )
    },
    /* @__PURE__ */ react.createElement(
      Image_d6406817.I,
      {
        ...t,
        className: a.articleGalleryImage,
        "data-testid": "article-image-gallery-image"
      }
    ),
    t.credits && /* @__PURE__ */ react.createElement("p", { className: a.articleGalleryCredits, itemProp: "creditText" }, r, ": ", t.credits),
    t.caption && /* @__PURE__ */ react.createElement("p", { className: a.articleGalleryCaption, itemProp: "caption" }, t.caption)
  ));
}

//# sourceMappingURL=ArticleImageGallery.js.map

// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/ArticleImageGallery/ArticleImageGallery.tsx








function ArticleImageGallery(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var imageNodes = (0,magnolia/* jcrMultiFieldToArray */.FE)(props.images);
    var images = imageNodes.map(function(node) {
        return mapImageNodeToArticleImage(node, imageDataHandler);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(b, {
        images: images,
        creditsLabel: t("assets.credits")
    });
}
function mapImageNodeToArticleImage(node, imageDataHandler) {
    var ref, ref1;
    var image = node.image, caption = node.caption, altText = node.altText;
    var imageData = imageDataHandler(image, {
        maxViewport: app/* Viewport.sm */.l_.sm
    });
    var title = (ref = image.metadata) === null || ref === void 0 ? void 0 : ref.title;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
        caption: caption,
        credits: image === null || image === void 0 ? void 0 : (ref1 = image.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights,
        altText: altText || title || caption || "Image"
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/ArticleImageGallery/index.ts
/* istanbul ignore file */ 


/***/ })

}]);